<template>
  <footer class="footer">
    <div class="container">
      <!-- PC端页脚 -->
      <div class="footer-pc d-none d-lg-block">
        <div class="footer-main">
          <div class="footer-left">
            <img src="@/assets/images/3975.png" alt="3975游戏" class="footer-logo">
          </div>
          <div class="footer-right">
            <div class="footer-links">
              <a href="https://www.3975.com/about" target="_blank">关于我们</a>
              <a href="https://www.3975.com/contact/index" target="_blank">联系我们</a>
              <a href="https://www.3975.com/public/webnew/39XY-2.html" target="_blank">用户协议</a>
              <a href="https://www.3975.com/zjjh/index/" target="_blank">家长监护</a>
              <a href="https://www.3975.com/personal/renzhen/" target="_blank">实名认证</a>
              <a href="https://www.3975.com/ticket/index/" target="_blank">申请开票</a>
              <a href="https://www.3975.com/yinsi/index" target="_blank">隐私政策</a>
              <a href="https://www.3975.com/worksystem/index" target="_blank">企业责任制度</a>
            </div>
            <div class="footer-copyright footer-company">
              广播电视节目制作经营许可证编号：<a :href="require('@/assets/images/zizhi.png')" target="_blank">(苏)字第03385号</a>
            </div>
            <div class="footer-copyright">
              公安备案号：苏公网安备32028102003326号
            </div>
            <div class="footer-company">
              江苏三九互网络科技有限公司 版权所有 信息产业部备案号：<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">苏ICP备16021564号-206</a>
            </div>
            <div class="footer-address">
              运营单位：江苏三九互网络科技有限公司
            </div>
          </div>
        </div>
        <div class="footer-certificates">
          <a class="cert-item" href="https://www.js12377.cn/" target="_blank">
            <img src="@/assets/images/legal-ico-jb.png" alt="江苏省互联网主办者备案不良信息举报">
            <span>江苏省互联网违法和<br>有害不良信息举报</span>
          </a>
          <a class="cert-item" href="https://www.12377.cn/" target="_blank">
            <img src="@/assets/images/legal-ico-2.png" alt="不良信息举报中心">
            <span>不良信息<br>举报中心</span>
          </a>
          <a class="cert-item" href="https://www.3975.com/public/webnew/foot/dengji.html" target="_blank">
            <img src="@/assets/images/legal-ico-3.png" alt="企业信用认证书">
            <span>企业信用评级<br>认证书</span>
          </a>
          <a class="cert-item" href="http://www.beian.gov.cn/portal/registerSystemInfo" target="_blank">
            <img src="@/assets/images/legal-ico-5.png" alt="">
            <span>公网备案信息<br>32028102003326号</span>
          </a>
        </div>
      </div>

      <!-- 移动端页脚 -->
      <div class="footer-mobile d-block d-lg-none">
        <div class="footer-icp-mobile">
          信息产业部备案号：<a style="" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">苏ICP备16021564号-206</a>
        </div>
        <div class="footer-icp-mobile">
          广播电视节目制作经营许可证编号：<a :href="require('@/assets/images/zizhi.png')" target="_blank">(苏)字第03385号</a>
        </div>
        <div class="footer-icp-mobile">
          公安备案号：苏公网安备32028102003326号
        </div>
        <div class="footer-company-mobile">
          江苏三九互网络科技有限公司 版权所有
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterSection'
}
</script>

<style lang="scss" scoped>
.footer-icp-mobile, .footer-company{
  a {
    text-decoration: underline;
    color: #ccc;
  }
}
</style>